<!-- <p-card>
    <div class="card">
        <img src="assets/imagem_home.png" width="150"/>
    </div>
</p-card>
     -->
     <div style="text-align: center; margin-top: 100px;">

        <img src="assets/imagem_home.png"/> 
    </div>
   